<template>
  <div class="map_panel">
    <div id='BDMap' class="map_container"></div>
    <!-- 信息窗 -->
    <div class="popup_panel" style="display: none;">
      <div class="popup_title" :class="{ plus: popupInfo.type == 3 || (popupInfo.type == 2 && popupInfo.level >= 3) }"
        ref="popup1">
        <div class="list_group" v-if="popupInfo.type == 1 && popupInfo.level < 3">
          <div class="group_cont">
            <div class="group_title">
              <div class="title_text">{{ setPopTitle(popupInfo) }}</div>
            </div>
            <div class="list_panel">
              <template v-for="item in popupLayerData">
                <div class="list_item">
                  <div class="item_title">{{ item.label }}：</div>
                  <div class="item_num"
                    :class="[{ active: item.label == '会员渠道' && !channelMapInfo.restricted }, item.label == '会员渠道' ? 'to_detail to_channel' : '']">
                    {{ item.value }}</div>
                </div>
              </template>
            </div>
            <div class="info_btns">
              <el-button size="mini" class="drill_btn">下钻</el-button>
            </div>
          </div>
        </div>
        <div class="list_group" v-else-if="popupInfo.type == 2 && popupInfo.level < 3">
          <div class="group_cont">
            <div class="group_title">
              <div class="title_text">终端信息</div>
            </div>
            <div class="list_panel">
              <div class="list_item">
                <div class="item_title">地区：</div>
                <div class="item_num">{{ popupInfo.areaName }}</div>
              </div>
              <div class="list_item">
                <div class="item_title">数量：</div>
                <div class="item_num">{{
                  popupInfo.type == 1 ? setNum(popupInfo.medBrokerNum) :
                    setNum(popupInfo.terminalNum)
                }}</div>
              </div>
              <!-- <div class="list_item" v-if="popupInfo.type == 1 && channelName">
                <div class="item_title">会员渠道：</div>
                <div class="item_num to_detail to_channel" :class="{ active: !channelMapInfo.restricted }">{{
                  channelName
                }}</div>
              </div> -->
            </div>
            <div class="info_btns">
              <el-button size="mini" class="drill_btn">下钻</el-button>
            </div>
          </div>
        </div>
        <div class="list_group" v-else-if="popupInfo.type == 3 || (popupInfo.type == 2 && popupInfo.level >= 3)">
          <div class="group_cont">
            <div class="group_title">
              <div class="title_text to_detail_page">{{ popupInfo.name }}</div>
              <div class="title_addr">{{ popupInfo.address }}</div>
              <div class="title_tags">
                <span class="tag_text" v-for="item in popupInfo.tags">{{ tagValue(item) }}</span>
              </div>
            </div>
            <div class="list_panel">
              <div class="list_item" v-for="item in popupInfo.list">
                <div class="item_title">{{ item.label }}：</div>
                <div class="item_num to_detail to_term"
                  :class="{ active: item.field == 'newestMaintainStaffName' && !channelMapInfo.restricted }">{{
                    item.value }}</div>
              </div>
              <div class="list_item" v-if="channelName && popupInfo.type == 2">
                <div class="item_title">会员渠道：</div>
                <div class="item_num to_detail to_channel" :class="{ active: !channelMapInfo.restricted }">{{
                  channelName
                  }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mark 富文本内容 -->
    <div class="map_icon_label_model" style="display: none;">
      <template v-for="item in layerList">
        <div class="label_item" :name="'label_' + item.id" :key="item.id" v-if="item.visible">
          <SvgIcon :name="item.icon" color="#fff" size="14" />
          <div class="label_info">0</div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
let BMapGL = null
import $ from 'jquery';
// 引入异步引入地图的方法
import { loadBaiDuMapAndExtendPlugs } from "@/api/bmpgl_lib.js";
import {
  changeNum,
  typeFilter,
  formatInt,
  setColor,
  getOrgMapData,
  getVisitMapData,
  getPointMapData,
  setBaseInfo,
  getStatisticsMapData
} from '@/api/portrait.js'

// 监听dom变化
import ElementResizeDetectorMaker from "element-resize-detector";

export default {
  props: {
    searchType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ak: 'enck8dGj9N87enQBk7NfgHPULQSLekIH',
      plugs: ['RichMarker', 'InfoBox'],
      bmap: null,
      map: null,
      mapZoom: 5,
      mapCenter: [104.188488, 34.302032],
      richMarks: [], // 服务人员 地图标签
      termMarks: [], // 终端 图标
      channelMarks: [], // 渠道 图标
      relateMarks: [], // 拜访客户 图标
      infoWindow: null,
      popupInfo: {
        areaName: '',
        medBrokerNum: '',
        fullBrokerNum: '',
        partBrokerNum: '',
        terminalNum: '',
        channelNum: ''
      },
      layerData: null,
      layerList: [],
      prevParams: null,
      listParams: {
        level: 0,
        type: [],
        code: '',
        terminalType: [],
        damId: ''
      },
      refreshLayer: true,
      options: null,
      currFeature: null,
      tipsNotify: null,
      prevFeature: [],
      disCountry: null,
      districtSearch: null,
      channelName: '',
      channelMapInfo: {
        params: {},
        data: null,
        prevFeature: []
      },
      currMouseInfo: {},
      prevMouseInfo: null,
      hlLayer: null,
      isSearchPosit: false,
      toFit: false,
      markZIndex: '',
      visibleLayerList: [],
      popupLayerData: []
    }
  },
  mounted() {
    this.$emit('getBDMapGL')
    this.initMap()
  },
  methods: {
    setNum(val) {
      return changeNum(val)
    },
    tagValue(row) {
      return typeFilter(row)
    },
    setPopTitle(info) {
      return this.visibleLayerList.length > 1 ? `${info.areaName}` : `${this.visibleLayerList[0].name.split('数量')[0]}信息`;
    },
    // 左下角信息提示框
    openNotify() {
      this.tipsNotify = this.$notify({
        duration: 0,
        offset: 0,
        position: 'bottom-left',
        dangerouslyUseHTMLString: true,
        message: `<div class="tips_panel" style="width: 300px; position: relative; padding-bottom: 30px;margin-left: -15px">
          <div class="panel_title" style="color: #212121;margin-bottom: 5px;">
            <img class="title_icon" src="${require('@/assets/map/map_tips_icon.png')}" alt="" style="width: 24px; height: 24px; margin-right: 5px; vertical-align: middle;">
            <span style="font-size: 16px">交互提示</span>
          </div>
          <div class="panel_con" style="color: #212121; font-size: 14px; padding-left: 35px">【双击】地图查看下一层级信息。</div>
          <button class="notify_close_btn" style="background: #FFFFFF; color: #4FA1A4; font-size: 12px; border: 1px solid rgba(79,161,164,1); border-radius: 2px; position: absolute; right: 0; bottom: 0;">我知道了</button>
        </div>`,
      });
      this.$nextTick(() => {
        const closeBtn = document.querySelectorAll('.notify_close_btn')
        closeBtn[0].onclick = (e) => {
          //在这里做点击的操作
          this.tipsNotify.close()
        }
        const aside = document.querySelectorAll('.el-main')[0]
        const notification = document.querySelectorAll('.el-notification')[0]
        notification.style.left = (aside.offsetLeft + 15) + 'px'

        let erd = ElementResizeDetectorMaker();
        erd.listenTo(aside, element => {
          notification.style.left = (element.offsetLeft + 15) + 'px';
        });
      })
    },
    // 初始化高德地图
    initMap() {
      // 传入密钥获取地图回调。
      if (this.bmap) {
        BMapGL = this.bmap
        this.loadMap()
      } else {
        loadBaiDuMapAndExtendPlugs(this.ak, this.plugs).then((BDMapGL) => {
          // 保存数据
          BMapGL = BDMapGL
          this.bmap = BDMapGL
          this.loadMap()
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 加载地图
    loadMap() {
      // 加载 图层
      // 创建地图实例
      this.map = new BMapGL.Map("BDMap", { minZoom: 4.5, maxZoom: 20 });
      // 创建点坐标 axios => res 获取的初始化定位坐标
      let point = new BMapGL.Point(this.mapCenter[0], this.mapCenter[1])
      // 初始化地图，设置中心点坐标和地图级别
      this.map.setViewport({ center: point, zoom: this.mapZoom }, {
        enableAnimation: false,
        // delay: 0
      })
      //开启鼠标滚轮缩放
      this.map.enableScrollWheelZoom(true)
      let _this = this
      // let center = null
      // this.map.addEventListener('zoomstart',(e) => {
      //     center = _this.map.getViewport().center
      // })
      // this.map.addEventListener('zoomend', (e) => {
      //     _this.map.setCenter(center)
      // })

      // //地图旋转角度
      // this.map.setHeading(10)
      // //地图倾斜角度
      // this.map.setTilt(19);
      // //设置map显示类型
      // //BMAP_EARTH_MAP 地图卫星模式
      // //BMAP_NORMAL_MAP 普通模式 默认
      // this.map.setMapType(BMAP_NORMAL_MAP)
      // //地图个性化样式
      // map.setMapStyleV2({
      //     styleId: 'a0c43e8c7279db0a4a032712d0e4c32c' //官网地图api个性化获取
      //     //   styleJson:[{}] //也可以json方式个性化
      // })

      // this.setAeraLayer()
      this.getLayerList()
      // if (!this.tipsNotify) {
      //     // this.openNotify()
      // }
    },
    // 设置区域图层
    setAeraLayer() {
      this.disCountry && this.disCountry.setMap(null);
      let code = this.listParams.code
      let level = this.listParams.level
      if (code == '') {
        this.disCountry = new AMap.DistrictLayer.Country({
          zIndex: 1,
          SOC: 'CHN',
          depth: 1,
          styles: {
            'nation-stroke': '#f09',
            'coastline-stroke': '#ddd',
            'province-stroke': '#333',
            'fill': '#f7f7f7'
          }
        })
      } else {
        this.disCountry = new AMap.DistrictLayer.Province({
          zIndex: 1,
          adcode: [code],
          depth: level > 2 ? 2 : 1,
          styles: {
            'province-stroke': '#673ab7',
            'city-stroke': level > 2 ? '#333' : '#673ab7',
            'county-stroke': level > 2 ? '#333' : '#673ab7',
            'fill': level > 2 ? '' : '#f7f7f7'
          }
        })
      }
      this.disCountry.setMap(this.map)
    },
    // 获取图层数据
    getLayerList() {
      if (this.infoWindow) {
        this.infoWindow.close()
        this.currFeature = null
        this.options = null
      }

      if (this.listParams.level < 3) {// 获取统计数据图层
        getStatisticsMapData(this.listParams).then(res => {
          const data = res.data || {};
          this.layerData = data;
          this.prevParams = JSON.parse(JSON.stringify(this.listParams));
          const labelData = data.label || {};
          const terminalData = data.terminal || {};
          this.initMarkAndLayer();
          this.addLayer(labelData.mapData, 1);
          this.addLayer(terminalData.mapData, 2);
        })
      } else { // 获取区级点数据
        getOrgMapData(this.listParams).then(res => {
          let mapData = res.data
          this.layerData = mapData
          this.prevParams = JSON.parse(JSON.stringify(this.listParams))
          this.initMarkAndLayer();
          for (var l in mapData) {
            (() => {
              this.addLayer(mapData[l].mapData, l)
            })()
          }
        })
      }
    },
    // 添加图层
    addLayer(layerData, type) {
      if (type == 2 && this.listParams.level < 3) {
        let layer = new BMapGL.GeoJSONLayer('layer_' + type, {
          reference: 'GCJ02',
          dataSource: layerData,
          level: -(5 + type), // 显示层级，GeoJSONLayer图层等级使用负数表达，负数越大层级越高，默认-99
          maxZoom: 13,        // 设置图层显示的地图最大等级
          // markerStyle: (pro) => this.setLayerStyle(pro, 'Point'),
          polygonStyle: (pro) => this.setLayerStyle(pro, 'Polygon'),
        });

        this.layerList = this.layerList.map(item => {
          if (item.id == type) {
            item.code = this.listParams.code
            item.layer = layer
            item.layer.addEventListener('click', this.showInfoOver)
            item.layer.setVisible(item.visible)
            this.map.addGeoJSONLayer(item.layer);
          }
          return item
        })
      } else {
        layerData.features.map(feature => {
          (() => {
            this.addRichMarkLayer(feature, type)
          })()
        })
        if (this.hlLayer) {
          this.setHLMarkZIndex()
        }
      }
      // 设置高亮及详情
      if (this.toFit && !this.isSearchPosit) {
        let toSet = false
        if (this.listParams.type.indexOf(2) > -1) {
          if (type == 2) {
            toSet = true
          }
        } else {
          if (this.listParams.type.indexOf(3) > -1) {
            toSet = true
          }
        }
        if (toSet) {
          this.setHeightlightLayer(layerData.features[0])
          let rows = layerData.features[0].properties
          let row = setBaseInfo(rows.externalAttributes, type)
          row.id = row.idCard || row.damId
          this.$emit('changeDetail', row)
        }
      }
    },
    // 添加 富文本标签图层
    addRichMarkLayer(feature, type = 1) {
      const { properties, geometry: { coordinates } } = feature;
      this.createMarkers(feature, coordinates, properties, type);
    },
    // 创建富文本标记
    createMarkers(feature, coor, properties, type) {
      let markerConfig = this.getMarkerConfig(properties, type);
      if (!markerConfig) return;

      const { content, anchor, collection } = markerConfig;
      const richMarker = new BMapGLLib.RichMarker(
        content,
        new BMapGL.Point(coor[0], coor[1]),
        { anchor: new BMapGL.Size(anchor[0], anchor[1]) }
      );

      // 添加到对应集合
      collection.push({ properties, mark: richMarker });

      // 添加事件和覆盖物
      this.map.addOverlay(richMarker);
      richMarker.removeEventListener("onclick", (evt) => this.showInfoOver(evt, feature));
      richMarker.addEventListener("onclick", (evt) => this.showInfoOver(evt, feature));

      // 特殊处理
      if (type == 1) {
        this.setHLMarkZIndex(type)
      } else if (type == 4) {
        this.setHLMarkZIndex()
      }
      this.$nextTick(() => {
        $('.map_icon_label').parent().css('transform', 'translateX(-14%)');
      })
    },
    // 获取标记配置
    getMarkerConfig(properties, type) {
      const { externalAttributes } = properties;

      switch (Number(type)) {
        case 1:
          const template = $('.map_icon_label_model').clone();
          template.find('.label_item').each((_, item) => {
            const $item = $(item);
            const labelId = $item.attr('name').split('_')[1];
            const value = {
              '1': changeNum(externalAttributes.medBrokerNum),
              '2': changeNum(externalAttributes.terminalNum),
              '3': changeNum(externalAttributes.channelNum)
            }[labelId] || '0';
            $item.find('.label_info').text(value);
          });
          return {
            content: `<div class="map_icon_label">${template.html()}</div>`,
            anchor: [-40, 10],
            collection: this.richMarks
          };

        case 2:
        case 4:
          const isSecondTerminal = externalAttributes.terminalType === '第二终端';
          let imgSrc = isSecondTerminal ?
            require('@/assets/map/point_zd_2.png') :
            require('@/assets/map/point_zd.png');

          if (externalAttributes.rank) {
            imgSrc = externalAttributes.rank === -1 ?
              require('@/assets/map/point_6.png') :
              require(`@/assets/map/point_${externalAttributes.rank}.png`);
          }

          return {
            content: `<img class="mark_icon ${externalAttributes.rank ? 'highlight_icon' : ''}" src="${imgSrc}" />`,
            anchor: [-18, -48],
            collection: type === 2 ? this.termMarks : this.relateMarks
          };

        case 3:
          if (externalAttributes.level >= 3) {
            const isMember = externalAttributes.isMember === '是';
            return {
              content: `<img class="mark_icon" src="${isMember ?
                require('@/assets/map/point_qd_ssas.png') :
                require('@/assets/map/point_qd_not.png')
                }" />`,
              anchor: [-18, -48],
              collection: this.channelMarks
            };
          }
          return {
            content: '<img class="mark_icon icon_circle" src="@/assets/map/point_circle.png" />',
            anchor: [-5, -5],
            collection: this.channelMarks
          };

        default:
          return null;
      }
    },
    // 高亮图层
    setHeightlightLayer(feature) {
      this.hlLayer && (this.map.removeOverlay(this.hlLayer), this.hlLayer = null);
      const { properties: pros, geometry: { coordinates } } = feature;
      const { type } = pros.externalAttributes;
      // 确定图标的类型名称
      const typeName = type === 2 ? pros.externalAttributes.terminalType : type === 3 ? pros.externalAttributes.isMember : '';
      this.createHlLayerMark(coordinates, feature, type, typeName);
    },
    // 创建高亮图标
    createHlLayerMark(coords, feature, type, typeName) {
      const point = new BMapGL.Point(coords[0], coords[1]);
      const content = `<img class="mark_icon highlight_icon point_0" src="${require('@/assets/map/point_act.png')}" name="${type + '_' + typeName}" />`;
      this.hlLayer = new BMapGLLib.RichMarker(content, point, {
        anchor: new BMapGL.Size(-18, -48)
      });
      // 添加交互事件
      this.hlLayer.addEventListener("onclick", (evt) => this.showInfoOver(evt, feature));
      // 添加到地图
      this.map.addOverlay(this.hlLayer);
      this.map.centerAndZoom(point, 13);
      this.setHLMarkZIndex()
    },
    setHLMarkZIndex(type) {
      this.$nextTick(() => {
        let doms = type ? document.querySelectorAll('.map_icon_label') : document.querySelectorAll('.highlight_icon')
        if (doms.length > 0) {
          doms.forEach(ele => {
            let dom = ele.parentElement
            this.markZIndex = dom.style.zIndex;
            if (type) {
              dom.style.zIndex = 100
            } else {
              let pointIndex = ele.className.split(' ').at(-1).split('_')[1]
              dom.style.zIndex = 100 - Number(pointIndex)
            }
          })
        }
      })
    },
    // 设置图层样式
    setLayerStyle(properties, geomType) {
      let pros = properties
      let type = pros.externalAttributes.type
      let level = pros.externalAttributes.level
      let fetch = null
      if (geomType == 'Point' || geomType == 'MultiPoint') {
        // if (type == 2) {
        //     let icon = `${require('@/assets/map/point_zd.png')}`
        //     let rank = pros.externalAttributes.rank
        //     if (rank) {
        //         icon = rank == -1 ? `${require('@/assets/map/point_6.png')}` : `${require('@/assets/map/point_' + rank + '.png')}`
        //     }
        //     fetch = {
        //         icon: new BMapGL.Icon(icon, new BMapGL.Size(36, 48), {
        //             anchor: new BMapGL.Size(18, 48),
        //             size: new BMapGL.Size(36, 48),
        //             imageSize: new BMapGL.Size(36, 48),
        //         }),
        //     }
        // } else if (type == 3) {
        //     let icon = `${require('@/assets/map/point_circle.png')}`
        //     fetch = {
        //         icon: new BMapGL.Icon(icon, new BMapGL.Size(10, 10), {
        //             anchor: new BMapGL.Size(5, 5),
        //             size: new BMapGL.Size(10, 10),
        //             imageSize: new BMapGL.Size(10, 10),
        //         }),
        //     }
        //     if (level >= 3) {
        //         icon = pros.externalAttributes.isMember == '是' ? `${require('@/assets/map/point_qd_ssas.png')}` : `${require('@/assets/map/point_qd_not.png')}`
        //         fetch = {
        //             icon: new BMapGL.Icon(icon, new BMapGL.Size(36, 48), {
        //                 anchor: new BMapGL.Size(18, 48),
        //                 size: new BMapGL.Size(36, 48),
        //                 imageSize: new BMapGL.Size(36, 48),
        //             }),
        //         }
        //     }
        // }
      } else if (geomType == 'Polygon' || geomType == 'MultiPolygon') {
        let code = pros.externalAttributes.terminalNum ? pros.externalAttributes.terminalNum : 0;
        const layerData = level < 3 ? this.layerData.terminal : this.layerData[2];
        let minValue = layerData.minValue <= 10 ? 10 : formatInt(layerData.minValue, true)
        let maxValue = layerData.maxValue <= 50 ? 50 : formatInt(layerData.maxValue, true)
        let color = setColor(code, minValue, maxValue);
        let per = Math.ceil((maxValue - minValue) / 6);
        let rang = [
          changeNum(minValue),
          changeNum(minValue + per),
          changeNum(minValue + per * 2),
          changeNum(minValue + per * 3),
          changeNum(minValue + per * 4),
          changeNum(minValue + per * 5),
          changeNum(maxValue)
        ]
        this.$emit('setColorRang', rang)

        fetch = {
          fillColor: color,
          fillOpacity: 0.7,
          strokeColor: '#909090',
          strokeWeight: 1,
          strokeOpacity: 0.7,
        };
      }

      return fetch
    },
    // 获取要素关联图层数据
    getDetailLayer(row) {
      let id = row.id
      let type = row.type
      this.channelName = row.name ? row.name : ''
      this.isSearchPosit = row.toPosit ? row.toPosit : false
      if (row.toPosit) {
        this.clearMarks()
      }
      if (type == 1) {
        if (this.channelName == '' || row.toPosit) {
          // 业务员详情
          getVisitMapData({ idCard: id }).then(res => {
            let data = res.data
            if (row.toPosit) {
              if (data.firstIndex == -1) {
                this.$message('该数据暂无拜访位置信息');
              }
            }
            setTimeout(() => {
              this.addLayer(data.mapData, 4)
            }, 3000)

          })
        } else {
          // 返回到会员渠道
          this.refreshMap('detail')
        }
      } else {
        if (row.toPosit) {
          if (row.code) {
            this.listParams.code = row.code
            this.listParams.level = row.level
            this.listParams.damId = id;
            this.getLayerList()
            // 终端、渠道搜索定位
            getPointMapData({ damId: id, type: type }).then(res => {
              let data = res.data
              // 设置高亮
              setTimeout(() => {
                this.setHeightlightLayer(data.mapData.features[0])
              }, 2000)
            })
          } else {
            this.$message('该数据暂无位置信息');
          }
        } else {
          this.clearMarks();
          this.listParams.code = ''
          this.listParams.level = 0
          if (this.channelName != '') {
            // 会员渠道关联人员及终端
            this.listParams.channelDamId = id
          } else {
            delete this.listParams.channelDamId
          }
          this.getLayerList()
          this.$emit('changeDetail', this.listParams, { prev: '全国', curr: '全国' })
          if (this.listParams.code == '') {
            let point = new BMapGL.Point(this.mapCenter[0], this.mapCenter[1])
            this.map.centerAndZoom(point, this.mapZoom)
            this.channelMapInfo.prevFeature = []
          }
        }
      }
    },
    initMarkAndLayer() {
      this.layerList.length && this.layerList.map(item => {
        item.layer && this.map.removeGeoJSONLayer(item.layer)
        item.layer && item.layer.removeEventListener('click', this.showInfoOver)
      })
      this.richMarks.map(item => {
        this.map.removeOverlay(item.mark)
      })
      this.richMarks = [];
      this.termMarks.map(item => {
        this.map.removeOverlay(item.mark)
      })
      this.termMarks = [];
      this.channelMarks.map(item => {
        this.map.removeOverlay(item.mark)
      })
      this.channelMarks = [];
      this.clearMarks();
    },
    // 清除 高亮 图标
    clearMarks() {
      this.relateMarks.map(item => {
        this.map.removeOverlay(item.mark)
      })
      this.relateMarks = [];
      this.hlLayer && (this.map.removeOverlay(this.hlLayer), this.hlLayer = null)
    },
    // 图层显隐
    changeLayerVisible(target) {
      // 1. 参数检查和简化条件判断
      if (JSON.stringify(this.listParams) !== JSON.stringify(this.prevParams)) {
        this.getLayerList();
        if (this.hlLayer == null && this.relateMarks.length === 0) {
          this.$emit('changeDetail', this.listParams);
        }
        return;
      }

      this.$emit('changeDetail');
      // 2. 查找当前图层配置
      const layerItem = this.layerList.find(item => item.id === target);
      if (!layerItem) return;

      const visible = layerItem.visible;
      // 3. 统一处理所有图层类型
      switch (target) {
        case 1:
          this.richMarks.map(item => {
            visible ? this.map.showOverlay(item.mark) : this.map.hideOverlay(item.mark)
          })
          break;
        case 2:
          // 类型2处理
          if (this.listParams.level >= 3) {
            this.termMarks.map(item => {
              visible ? this.map.showOverlay(item.mark) : this.map.hideOverlay(item.mark)
            })
          } else {
            layerItem.layer?.setVisible(visible);
          }
          break;
        case 3:
          this.channelMarks.map(item => {
            visible ? this.map.showOverlay(item.mark) : this.map.hideOverlay(item.mark)
          })
          break;
      }
    },
    // 显示气泡
    showInfoOver(evt, feature) {
      if (feature || evt.features) {
        if (this.currFeature == null) {// 设置并显示气泡
          let polygon = feature ? evt.target : evt.features[0]
          let extData = feature ? feature.properties : polygon.properties
          let row = extData.externalAttributes
          let type = feature && row.level < 3 ? 1 : row.type, typeName = '', level = row.level;
          row = setBaseInfo(row, type)
          if (type == 2) {
            typeName = row.terminalType
          } else if (type == 3) {
            typeName = row.isMember
          }
          this.popupInfo = { ...JSON.parse(JSON.stringify(row)), type };

          if (level >= 3 && type != 1) {
            if (polygon instanceof BMapGLLib.RichMarker) {
              this.options = {
                content: polygon.getContent()
              }
              let content = `<img class="mark_icon highlight_icon point_0" src="${require('@/assets/map/point_act.png')}" />`
              polygon.setContent(content)
            } else {
              // this.options = {
              //     icon: polygon.getIcon()
              // }
              // let icon = new BMapGL.Icon(`${require('@/assets/map/point_act.png')}`, new BMapGL.Size(36, 48), {
              //     anchor: new BMapGL.Size(18, 48),
              //     size: new BMapGL.Size(36, 48),
              //     imageSize: new BMapGL.Size(36, 48),
              // })
              // polygon.setIcon(icon)
            }
            if (this.hlLayer) {
              let props = this.hlLayer.domElement.children[0].getAttribute('name')
              if (props) {
                props = props.split('_')
                let type = Number(props[0]), typeName = props[1]
                let content = ''
                if (type == 2) {
                  content = `<img class="mark_icon" src="${typeName == '第二终端' ? require('@/assets/map/point_zd_2.png') : require('@/assets/map/point_zd.png')}" />`
                } else if (type == 3) {
                  content = `<img class="mark_icon" src="${typeName == '是' ? require('@/assets/map/point_qd_ssas.png') : require('@/assets/map/point_qd_not.png')}" />`
                }
                this.hlLayer && this.hlLayer.setContent(content)
              }
            }

            if (this.channelName == '') {
              this.channelMapInfo.params = this.listParams
              this.channelMapInfo.data = row
              let info = JSON.parse(JSON.stringify(row))
              info.id = row.idCard || row.damId
              this.$emit('changeDetail', info)
            }
          } else {
            if (type == 2) {
              this.options = {
                fillColor: polygon.getFillColor()
              }
              polygon.setFillColor('#83C0FF')
            } else {
              this.visibleLayerList = this.layerList.filter(l => l.visible);
              const visibleLayerLength = this.visibleLayerList.length;
              this.popupLayerData = [];
              this.visibleLayerList.map(item => {
                if (visibleLayerLength == 1) {
                  this.popupLayerData.push({
                    label: '地区',
                    value: row.areaName
                  })
                  this.popupLayerData.push({
                    label: '数量',
                    value: item.id == 1 ? changeNum(row.medBrokerNum) : item.id == 2 ? changeNum(row.terminalNum) : changeNum(row.channelNum)
                  })
                  if (this.channelName && item.id == 1) {
                    this.popupLayerData.push({
                      label: '会员名称',
                      value: this.channelName
                    })
                  }
                } else {
                  this.popupLayerData.push({
                    label: item.name,
                    value: item.id == 1 ? changeNum(row.medBrokerNum) : item.id == 2 ? changeNum(row.terminalNum) : changeNum(row.channelNum)
                  })
                }
              })
            }
          }

          if (type == 2 || type == 3) {
            let list = [
              { field: 'newestMaintainTime', label: '近期拜访时间', value: row.newestMaintainTime },
              { field: 'newestMaintainStaffName', label: '服务人员', value: row.newestMaintainStaffName },
            ]
            this.popupInfo.list = list
          }

          this.currFeature = polygon
          const coordinates = feature ? feature.geometry.coordinates : (extData.center || [row.lng, row.lat]);
          this.createInfoWindow(coordinates, feature, type, row);
        } else {// 关闭其他气泡
          if (this.options) {
            // this.options.icon && this.currFeature.setIcon(this.options.icon);
            this.options.content && this.currFeature.setContent(this.options.content);
            this.options.fillColor && this.currFeature.setFillColor(this.options.fillColor);
            let hlayerMarkDom = this.currFeature.domElement;
            hlayerMarkDom && (hlayerMarkDom.style.zIndex = this.markZIndex);
          }
          this.currFeature = null
          this.options = null
          this.showInfoOver(evt, feature)
        }
      }
    },
    // 创建信息窗
    createInfoWindow(coords, feature, type, row) {
      let point = new BMapGL.Point(coords[0], coords[1]);
      let offset = row.level < 3 ? new BMapGL.Size(0, -15) : new BMapGL.Size(0, 40)
      this.$nextTick(() => {
        let opts = {
          offset: offset,
          closeIconMargin: "0px 8px 0 0",
          closeIconUrl: require('@/assets/map/close_icon.png'),
          enableAutoPan: false, //启用自动平移
        };
        let content = this.$refs.popup1.outerHTML
        this.infoWindow && this.infoWindow.close()
        this.infoWindow = new BMapGLLib.InfoBox(this.map, content, opts); // 创建信息窗口对象
        let marker = new BMapGL.Marker(point);
        this.infoWindow.open(marker)
        this.infoWindow.addEventListener('open', (e) => {
          setTimeout(() => {
            // 1. 处理业务逻辑
            if (row.level < 3) {
              type === 3 ? this.toDetail(type, row) : this.mapDrill(feature);
            } else {
              this.toDetail(type, row);
              this.backDetail();
            }
            // 2. 设置高亮图标层级
            this.setHLMarkZIndex();
            // 3. 优化后的信息窗口位置调整逻辑
            this.adjustInfoWindowPosition();
          }, 100)
        })
      })
    },
    /**
     * 自动调整信息窗口位置确保完全可见
    **/
    adjustInfoWindowPosition() {
      const infoWindowEl = document.querySelector('.infoBox');
      const mapContainerEl = document.getElementById('BDMap');

      if (!infoWindowEl || !mapContainerEl) return;

      const searchBarHeight = 145;
      const mapRect = mapContainerEl.getBoundingClientRect();
      const infoRect = infoWindowEl.getBoundingClientRect();
      const padding = 15;

      // 计算可视区域边界（包含搜索栏）
      const viewport = {
        top: mapRect.top + searchBarHeight,
        bottom: mapRect.bottom,
        left: mapRect.left,
        right: mapRect.right
      };

      // 1. 计算各方向溢出量
      const overflow = {
        top: viewport.top - infoRect.top,
        bottom: infoRect.bottom - viewport.bottom,
        left: viewport.left - infoRect.left,
        right: infoRect.right - viewport.right
      };

      // 2. 只收集确实需要调整的方向
      const adjustments = {};
      if (overflow.top > 0) adjustments.top = overflow.top + padding;
      if (overflow.bottom > 0) adjustments.bottom = overflow.bottom + padding;
      if (overflow.left > 0) adjustments.left = overflow.left + padding;
      if (overflow.right > 0) adjustments.right = overflow.right + padding;

      // 3. 如果有需要调整的方向
      if (Object.keys(adjustments).length > 0) {
        this.smoothMapPan(adjustments);
      }
    },
    /**
     * 平滑移动地图位置
     * @param {number} offsetY Y轴偏移像素值
    **/
    smoothMapPan(adjust) {
      const currentCenter = this.map.getCenter();
      const currentPixel = this.map.pointToPixel(currentCenter);

      // 初始无偏移
      let offsetX = 0;
      let offsetY = 0;

      // 只应用实际需要调整的方向
      if ('top' in adjust) offsetY -= adjust.top;
      if ('bottom' in adjust) offsetY += adjust.bottom;
      if ('left' in adjust) offsetX -= adjust.left;
      if ('right' in adjust) offsetX += adjust.right;

      // 计算新中心点（仅在需要移动的方向上调整）
      const newPixel = new BMapGL.Pixel(
        currentPixel.x + offsetX,
        currentPixel.y + offsetY
      );

      const newCenter = this.map.pixelToPoint(newPixel);

      // 执行移动（添加缓动效果）
      this.map.panTo(newCenter, {
        noAnimation: false,
        animationDuration: 300,
      });
    },
    // 地图下钻
    mapDrill(feature) {
      let _this = this
      const btn = document.querySelectorAll('.infoBox .drill_btn')
      if (btn.length == 0) return
      btn[0].onclick = (e) => {
        //在这里做点击的操作
        if (feature) {
          _this.refreshMap('down', feature.properties)
        } else {
          _this.refreshMap('down')
        }
      }
    },
    // 返回上一层级
    refreshMap(type, info) {
      let extData = { externalAttributes: { level: -1 }, adcode: '', name: '全国' }
      if (type == 'down') {
        extData = info ? info : this.currFeature.properties
      } else if (type == 'detail') {
        extData = this.channelMapInfo.prevFeature.at(-1).properties
      } else {
        if (type.level == 'town') {
          this.clearMarks()
          if (this.toFit) {
            this.refreshMap({ level: 'dist', name: type.name, toFit: 'fit' })
            return
          } else {
            if (this.channelName == '') {
              if (this.prevFeature.length <= 2) {
                extData = typeof (this.prevFeature[1].name) != 'undefined' ? this.prevFeature[1] : this.prevFeature[1].properties
              } else {
                extData = typeof (this.prevFeature[2].name) != 'undefined' ? this.prevFeature[2] : this.prevFeature[2].properties
              }
            } else {
              if (this.channelMapInfo.prevFeature.length <= 2) {
                extData = typeof (this.channelMapInfo.prevFeature[1].name) != 'undefined' ? this.channelMapInfo.prevFeature[1] : this.channelMapInfo.prevFeature[1].properties
              } else {
                extData = typeof (this.channelMapInfo.prevFeature[2].name) != 'undefined' ? this.channelMapInfo.prevFeature[2] : this.channelMapInfo.prevFeature[2].properties
              }
            }
          }
        } else if (type.level == 'dist') {
          if (this.channelName == '') {
            if (type.name.indexOf('北京') > -1 || type.name.indexOf('天津') > -1 || type.name.indexOf('上海') > -1 || type.name.indexOf('重庆') > -1) {
              extData = typeof (this.prevFeature[0].name) != 'undefined' ? this.prevFeature[0] : this.prevFeature[0].properties
            } else {
              extData = typeof (this.prevFeature[1].name) != 'undefined' ? this.prevFeature[1] : this.prevFeature[1].properties
            }
          } else {
            if (type.name.indexOf('北京') > -1 || type.name.indexOf('天津') > -1 || type.name.indexOf('上海') > -1 || type.name.indexOf('重庆') > -1) {
              extData = typeof (this.channelMapInfo.prevFeature[0].name) != 'undefined' ? this.channelMapInfo.prevFeature[0] : this.channelMapInfo.prevFeature[0].properties
            } else {
              extData = typeof (this.channelMapInfo.prevFeature[1].name) != 'undefined' ? this.channelMapInfo.prevFeature[1] : this.channelMapInfo.prevFeature[1].properties
            }
          }
        } else if (type.level == 'city') {
          if (type.name != '全国') {
            if (type.name.indexOf('北京') > -1 || type.name.indexOf('天津') > -1 || type.name.indexOf('上海') > -1 || type.name.indexOf('重庆') > -1) {
              if (this.channelName == '') {
                extData = typeof (this.prevFeature[0].name) != 'undefined' ? this.prevFeature[0] : this.prevFeature[0].properties
              } else {
                extData = typeof (this.channelMapInfo.prevFeature[0].name) != 'undefined' ? this.channelMapInfo.prevFeature[0] : this.channelMapInfo.prevFeature[0].properties
              }
            } else {
              if (this.channelName == '') {
                extData = typeof (this.prevFeature[0].name) != 'undefined' ? this.prevFeature[0] : this.prevFeature[0].properties
              } else {
                extData = typeof (this.channelMapInfo.prevFeature[0].name) != 'undefined' ? this.channelMapInfo.prevFeature[0] : this.channelMapInfo.prevFeature[0].properties
              }
            }
          }
        }
      }

      let row = extData.externalAttributes
      let level = row.level
      let distName = extData.name || '全国'
      let prev = '全国'
      if (type == 'down') {
        this.listParams.level = level + 1
        this.listParams.code = extData.adcode
        // 渠道关联数据下钻 不更新
        if (this.channelName == '') {
          if (this.prevFeature.length) {
            let name = this.prevFeature[0].name || this.prevFeature[0].properties.name
            // 直辖市
            if (name.indexOf('北京') > -1 || name.indexOf('天津') > -1 || name.indexOf('上海') > -1 || name.indexOf('重庆') > -1) {
              if (level == 2 && level >= this.prevFeature.length) {
                prev = this.prevFeature[level - 2].name || this.prevFeature[level - 2].properties.name
                this.prevFeature[level - 1] = info ? info : this.currFeature
              } else {
                prev = this.prevFeature[level - 1].name || this.prevFeature[level - 1].properties.name
                this.prevFeature[level] = info ? info : this.currFeature
              }
            } else {
              prev = this.prevFeature[level - 1].name || this.prevFeature[level - 1].properties.name
              this.prevFeature[level] = info ? info : this.currFeature
            }
          } else {
            this.prevFeature[level] = info ? info : this.currFeature
          }
        } else {
          prev = this.channelMapInfo.prevFeature.length ? (this.channelMapInfo.prevFeature[level - 1].name || this.channelMapInfo.prevFeature[level - 1].properties.name) : '全国'
          if (level == this.channelMapInfo.prevFeature.length) {
            this.channelMapInfo.prevFeature[level] = info ? info : this.currFeature
          } else {
            this.channelMapInfo.prevFeature[level - 1] = info ? info : this.currFeature
          }
        }
      } else if (type == 'detail') {
        this.listParams = this.channelMapInfo.params
        prev = extData.name
      } else {
        this.listParams.level = level + 1
        this.listParams.code = extData.adcode
        if (type.level == 'town') {
          if (this.prevFeature.length <= 2) {
            prev = this.channelName == '' ? (this.prevFeature[0].name || this.prevFeature[0].properties.name) : (this.channelMapInfo.prevFeature[0].name || this.channelMapInfo.prevFeature[0].properties.name)
          } else {
            prev = this.channelName == '' ? (this.prevFeature[1].name || this.prevFeature[1].properties.name) : (this.channelMapInfo.prevFeature[1].name || this.channelMapInfo.prevFeature[1].properties.name)
          }
        } else if (type.level == 'dist') {
          if (type.name.indexOf('北京') == -1 && type.name.indexOf('天津') == -1 && type.name.indexOf('上海') == -1 && type.name.indexOf('重庆') == -1) {
            prev = this.channelName == '' ? (this.prevFeature[0].name || this.prevFeature[0].properties.name) : (this.channelMapInfo.prevFeature[0].name || this.channelMapInfo.prevFeature[0].properties.name)
          }
        }
        if (this.listParams.code == '') {
          if (this.channelName == '') {
            this.prevFeature = []
          } else {
            this.channelMapInfo.prevFeature = []
          }
        }
      }

      // this.setAeraLayer()
      level < 3 && this.clearMarks();
      this.toFit = (this.listParams.level > 2 && this.listParams.type.indexOf(1) == -1 && (type == 'down' || type == 'detail'))
      const mapParams = JSON.parse(JSON.stringify(this.listParams));
      if (distName.indexOf('行政区划') > -1) {
        if (type != 'down' && type.level == 'dist') {
          this.listParams.level = 1;
          this.listParams.code = this.prevFeature[0].adcode;
          this.getLayerList();
        }
      } else {
        this.getLayerList();
      }
      !this.toFit && this.$emit('changeDetail', mapParams, { prev: prev, curr: distName, down: type == 'down' || type == 'detail', toFit: type.toFit })

      if (mapParams.code == '') {
        let point = new BMapGL.Point(this.mapCenter[0], this.mapCenter[1])
        this.map.centerAndZoom(point, this.mapZoom)
      } else {
        const centerName = this.getCenterName(mapParams, extData, prev);
        const zoom = mapParams.level <= 1 ? 8 : mapParams.level == 2 ? 11.5 : 13;
        new BMapGL.Geocoder().getPoint(centerName, (point) => {
          if (point) {
            // 设置地图中心点和缩放级别
            this.map.centerAndZoom(point, zoom);
          }
        }, prev); // 指定使用行政区划代码搜索
      }
    },
    getCenterName(params, extData, prev) {
      if (params.level <= 1) {
        // 国家级或省级直接使用当前名称
        return extData.name;
      } else {
        // 特殊处理
        if (prev.indexOf('行政区划') == -1) {
          return extData.name;
        }
        // 获取从省级开始到当前层级的名称组合
        const names = this.prevFeature.map(f => f.name);
        // 移除可能的空值并拼接
        return names.filter(name => !!name).join('');
      }
    },
    // 回到详情
    backDetail() {
      let _this = this
      const btn = document.querySelectorAll('.to_detail.active')
      btn.forEach(ele => {
        ele.onclick = (e) => {
          if (e.target.className.indexOf('to_term') > -1) {// 返回服务人员详情
            let info = JSON.parse(JSON.stringify(_this.popupInfo))
            info.id = info.newestMaintainStaffIdCard
            info.type = 1
            _this.$emit('backDetail', info)
          } else {// 返回会员渠道详情
            // _this.$emit('backDetail', 2)
          }
        }
      })

    },
    // 跳转至详情页
    toDetail(type, row) {
      const btn = document.querySelectorAll('.to_detail_page')
      btn[0].onclick = (e) => {
        let info = setBaseInfo(row, type)
        let queryInfo = this.$route.query
        queryInfo.type = type
        queryInfo.data = JSON.stringify([info])
        queryInfo.from = 'home'
        let pathInfo = this.$router.resolve({
          path: '/portrait/salesmanDetail',
          query: queryInfo
        })
        window.open(pathInfo.href, '_blank');
      }
    },
  }
}
</script>

<style lang="less" scoped>
.map_panel,
.map_container {
  width: 100%;
  height: 100%;
}

/deep/.map_icon_label {
  display: flex;
  align-items: center;
  font-size: 12px;
  background: #FF854D;
  padding: 3px 8px;
  border-radius: 12px;
  position: relative;

  &::after {
    content: ''; //一定要有它，否则效果出不来
    position: absolute; //给高亮元素定位，在这之前要给statusItem元素设置position:relative定位
    left: 50%;
    top: -8px;
    transform: translate(-50%, 0); //居中显示
    border: 4px solid transparent; //小三角的大小
    border-bottom-color: #FF854D; //小三角朝下
  }

  .label_icon {
    width: 20px;
    height: 20px;
    background: #FF854D;
    padding: 0 2px;
  }

  .svg-icon {
    margin-right: 2px;
  }

  .label_info {
    color: #fff;
    height: 100%;
    font-weight: 600;
  }
}

/deep/.mark_icon {
  width: 36px;

  &.icon_circle {
    width: 10px;
  }
}

/deep/.amap-marker {
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.popup_title {
  width: 180px;
  display: flex;
  align-items: center;
  padding: 5px;

  &.plus {
    width: 300px;
    cursor: default;
  }

  .title_cont {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    font-size: 14px;

    .title_text {
      color: #212121;
      line-height: 24px;
      font-weight: 600;
    }

    .title_num {
      font-size: 16px;
      color: #999;
      text-align: right;
      line-height: 24px;
    }
  }
}

.popup_body {
  width: 300px;
}

.list_group {
  width: 100%;
  display: flex;
  text-align: left;
  cursor: default;
}

.plus .list_group {
  .group_title {
    &:hover {
      .title_text {
        color: #4FA1A4;
        cursor: pointer;
      }
    }
  }
}

.group_icon {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  background: #d9d9d9;
  color: #fff;
  margin: 5px 10px 0 0;

  &.one {
    background: #fb2323;
  }

  &.tow {
    background: #ff854d;
  }

  &.three {
    background: #ffd52e;
  }
}

.group_cont {
  width: 100%;

  .group_title {
    margin-bottom: 10px;

    .title_text {
      font-size: 14px;
      color: #212121;
      line-height: 30px;
      font-weight: 600;
    }

    .title_addr {
      font-size: 14px;
      color: #666666;
      line-height: 21px;
      font-weight: 400;
      margin-bottom: 10px;
    }

    .title_tags {
      font-size: 12px;

      span {
        display: inline-block;
        padding: 5px;
        background: #EBF6F7;
        border-radius: 2px;
        color: #4FA1A4;
        margin-right: 5px;
      }
    }
  }


  .list_panel {

    .list_item {
      display: flex;
      align-items: center;
      font-size: 12px;

      .item_title {
        color: #666;
        line-height: 20px;
      }

      .item_num {
        color: #212121;

        &.active {
          color: #4FA1A4;
          cursor: pointer;
        }
      }
    }
  }
}

.info_btns {
  text-align: right;
}

/deep/.amap-info-close {
  font-weight: normal;
  color: #666;
}

/deep/.amap-logo,
/deep/.amap-copyright {
  display: none !important;
}

/deep/.tips_panel {
  color: #212121;

  .panel_title {
    font-size: 16px;

    .title_icon {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }

  .panel_con {
    .close_btn {
      color: #4FA1A4;
    }
  }
}

/deep/#platform {
  div {
    background-color: transparent !important;
  }

  .map_icon_label {
    background-color: #ff854d !important;

    .label_item {
      display: flex;
      align-items: center;
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .infoBox {
    background: #fff !important;
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    position: relative;

    >img {
      width: 16px;
    }

    &::before,
    &::after {
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      z-index: 1;
      bottom: -9px;
      left: 50%;
      transform: translateX(-50%);
      border-style: solid;
      border-width: 9px 9px 0;
      border-color: #d9d9d9 transparent transparent;
    }

    &::after {
      bottom: -8px;
      border-color: #fff transparent transparent;
    }
  }

  .shadow {
    display: none !important;
  }
}
</style>
